import { SwitchSizeConfig, SWITCH_SIZES } from "./types";

export const SIZE_CONFIG_MAP: Record<SWITCH_SIZES, SwitchSizeConfig> = {
  [SWITCH_SIZES.LARGE]: {
    width: 44,
    height: 24,
    textClass: "body-lg",
  },
  [SWITCH_SIZES.MEDIUM]: {
    width: 40,
    height: 20,
    textClass: "body-md",
  },
  [SWITCH_SIZES.SMALL]: {
    width: 32,
    height: 16,
    textClass: "body-sm",
  },
};
